const {
  REGEXP_IS_UUID,
  REGEXP_IS_HEX_COLOR,
  REGEXP_IS_EMAIL_SIMPLE,
  REGEXP_IS_HTTP_SIMPLE,
  REGEXP_IS_HTTP_NOT_LOCALHOST
} = require('../constants/regexp')

const { PhoneNumberUtils } = require('@sigmasms/commons')

const isUUID = (input = '') => {
  if (typeof input !== 'string' || !REGEXP_IS_UUID.test(input)) {
    return false
  }

  return input
}
exports.isUUID = isUUID

const isHEXColor = v => {
  const matches = ('' + v).match(REGEXP_IS_HEX_COLOR)

  return matches && matches[1] ? '#' + matches[1] : undefined
}
exports.isHEXColor = isHEXColor

/**
 * Checks input for valid phone number
 *
 * @param {string} [input=''] Potential phone number
 * @param {any} [options={}] Options object
 * @param {array} options.pntFilter all lpnPNT type names, case sensitive
 * @param {array} options.typeFilter mobile, home or work
 * @returns
 */
const isPhoneNumber = (input = '', options = {}) => PhoneNumberUtils.isPhoneNumber(input, options)
exports.isPhoneNumber = isPhoneNumber

exports.isEmail = input => typeof input === 'string' && REGEXP_IS_EMAIL_SIMPLE.test(input) ? input : undefined

const httpRegExps = {
  HTTPsSimple: REGEXP_IS_HTTP_SIMPLE,
  HTTPsSimpleNotLH: REGEXP_IS_HTTP_NOT_LOCALHOST
}
exports.isURL = (input, type = 'HTTPsSimple') =>
  typeof input === 'string' && httpRegExps[type].test(input) ? input : undefined

exports.isValidDate = d => d instanceof Date && !isNaN(d)

exports.isSimpleObject = value => typeof value === 'object' && value !== null && !Array.isArray(value) && !exports.isValidDate(value)
